<template>
    <div id="app">
        <page-preloader v-if="isInitialLoader" />
        <template v-else>
            <the-notifications />
            <modal-base v-if="showModal" />
            <confirmation-window v-if="showConfirmationWindow" />
            <the-header />
            <router-view :key="$route.fullPath" />
            <the-footer />
            <ios-prompt v-if="showPrompt" :auto-show="true" />
        </template>
    </div>
</template>

<script>
import TheNotifications from '@/components/layout/TheNotifications'
import TheHeader from '@/components/header/TheHeader'
import TheFooter from '@/components/footer/TheFooter'
import ModalBase from '@/components/global/ui/ModalBase.vue'
import ConfirmationWindow from '@/components/global/ui/ConfirmationWindow.vue'
import IosPrompt from '@/components/modals/IosPrompt.vue'

export default {
    name: 'App',
    data() {
        return {
            logged: false,
            showPrompt: false
        }
    },
    components: {
        TheHeader,
        TheFooter,
        TheNotifications,
        ModalBase,
        IosPrompt,
        ConfirmationWindow
    },
    computed: {
        showModal() {
            return this.$store.getters.modalState.show
        },
        showPreview() {
            return this.$store.getters.getPreviewShow
        },
        showConfirmationWindow() {
            return this.$store.getters.showConfirmationWindow
        },
        isLogged() {
            return this.$store.getters.isLogged
        },
        isInitialLoader() {
            return this.$store.getters.authStatus === 'pending'
        }
    },
    methods: {
        setUserDeviceType() {
            const isIos = () => {
                const userAgent = window.navigator.userAgent.toLowerCase()
                return /iphone|ipad|ipod/.test(userAgent)
            }
            // Detects if device is in standalone mode
            const isInStandaloneMode = () =>
                'standalone' in window.navigator && window.navigator.standalone

            // Checks if should display install popup notification:
            if (isIos() && !isInStandaloneMode()) {
                this.showPrompt = true
            }

            this.$store.dispatch(
                'setUserDeviceType',
                /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
                    navigator.userAgent
                )
                    ? 'mobile'
                    : 'desktop'
            )
        }
    },
    watch: {
        $route(to, from) {
            this.$store.dispatch('fetchAppData')
            if (!this.$store.getters.getUserDeviceType) {
                this.setUserDeviceType()
            }
        }
    },
    async created() {
        const token = await this.$store.$storage.getItem('authToken')
        this.$store.dispatch('setAuthToken', token)
        this.$store.dispatch('setDefaultPerPage')
    },
    mounted() {
        this.setUserDeviceType()
    },
    beforeDestroy() {
        this.$store.dispatch('removeGeneratedLink')
    }
}
</script>
